import mitt from 'mitt'

enum StorageKeys {
  PendingFeebback = 'pending-feedback'
}

type Events = {
  feedbackChange: boolean
}

const emitter = mitt<Events>()

class LocalStorageService {
  public pendingFeedback: boolean | undefined

  constructor() {
    this.pendingFeedback = this.getPendingFeedback()
  }

  setPendingFeedback(value: boolean) {
    this.pendingFeedback = value
    const stringValue = value ? '1' : '0'
    localStorage.setItem(StorageKeys.PendingFeebback, stringValue)
    emitter.emit('feedbackChange', value)
  }

  getPendingFeedback(): boolean | undefined {
    const stringValue = localStorage.getItem(StorageKeys.PendingFeebback)
    return stringValue ? stringValue === '1' : undefined
  }

  onFeedbackChange(callback: (value: boolean) => void) {
    emitter.on('feedbackChange', callback)
  }

  offFeedbackChange(callback: (value: boolean) => void) {
    emitter.off('feedbackChange', callback)
  }
}

export const localStorageService = new LocalStorageService()
